import { PageLink } from 'assets/layout/core'

export const breadcrumbView: PageLink[] = [
  {
    title: 'Itens',
    path: '/commercial/dishes',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
